/*
 * @Author: 梅豆
 * @Date: 2024-06-17 09:45:40
 * @LastEditors: 方宾菲
 * @LastEditTime: 2025-02-20 15:29:13
 * @FilePath: \ys.gnss\src\api\fileUpOrDownload\index.js
 * @Description: 
 */
import request from '../request'
import imgRequest from '../imgRequest'
import axios from 'axios'
import store from '@/store'

//查询文件数据
export function searchFileList(params) {
  return request.post('/api/common-file/dmtgl/getDownloadQueryNo', params);
}

//图片文件预览
export function imgFileLook(params) {
  return imgRequest.get('/api/common-file/dmtgl/show', {params:params, responseType:"blob"});
}

//文件删除
export function delFile(params) {
  return request.get('/api/common-file/dmtgl/delete', {params:params});
}

//文件下载
export function downloadFile(params) {
  return imgRequest.get('/api/common-file/dmtgl/Download', {params:params,responseType:"blob"});
}

export function upload(params,onUploadProgress) {
  return axios({
    method:"post",
    data:params,
    url:"/api/common-file/dmtgl/Upload",
    headers:{
      "Content-Type":"application/x-www-form-urlencoded",
      Authorization:store.state.user.token,
      'OPT_CODE':store.state.user.cddmlj
    },
    onUploadProgress:onUploadProgress,
    timeout: 20000,
  })
}